import React from "react";
import Link from "theme/components/atoms/Typography/Link/Link";
import Svg from "theme/components/atoms/Icon/Svg";
import { useIntl, defineMessages } from "react-intl";

const Socials = (props) => {
  const intl = useIntl();
  const messages = defineMessages({
    linkedin: {
      id: "layout.Footer.BottomBar.Socials.linkedin",
      defaultMessage: "LinkedIn",
    },
    instagram: {
      id: "layout.Footer.BottomBar.Socials.instagram",
      defaultMessage: "Instagram",
    },
    facebook: {
      id: "layout.Footer.BottomBar.Socials.facebook",
      defaultMessage: "Facebook",
    },
    viadeo: {
      id: "layout.Footer.BottomBar.Socials.viadeo",
      defaultMessage: "Viadeo",
    },
  });

  const datas = [
    {
      link: props.linkedinLink,
      icon: "linkedin",
      label: intl.formatMessage(messages.linkedin),
    },
    {
      link: props.instagramLink,
      icon: "instagram",
      label: intl.formatMessage(messages.instagram),
    },
    {
      link: props.facebookLink,
      icon: "facebook",
      label: intl.formatMessage(messages.facebook),
    },
    {
      link: props.viadeoLink,
      icon: "viadeo",
      label: intl.formatMessage(messages.viadeo),
    },
  ];

  return (
    <div className="social-media">
      <ul className="icon-list">
        {datas.map((data) =>
          data.link ? (
            <li key={data.icon}>
              <Link
                to={data.link}
                external
                aria-label={data.label}
                buttonAppearance="none"
                primary={false}
                related={false}
                buttonSize="medium"
                noSpan={true}
              >
                <Svg type={data.icon} />
              </Link>
            </li>
          ) : null
        )}
      </ul>
    </div>
  );
};

export default Socials;
